export default `query
{
  hasDraft(flowName:"{{flowName}}",id: "{{id}}", kind: {{kind}})
}`;